import type React from 'react';

import { useGetPermissionTags } from '@vlabs/api/artemy/client';
import type { PermissionTag } from '@vlabs/api/artemy/model';
import { parseISOToLocale } from '@vlabs/shared/utils/date';
import { useTranslation } from 'react-i18next';

import { valueOrHyphen } from '@vlabs/monokit/shared/lib/utils';

import st from './PermissionTagGeneralInfo.module.sass';

export interface PermissionTagGeneralInfoProps {
  permissionTag: PermissionTag;
}

function PermissionTagGeneralInfo({
  permissionTag,
}: PermissionTagGeneralInfoProps): React.JSX.Element {
  const { t } = useTranslation();
  const getPermissionTags = useGetPermissionTags({ permission_tags: permissionTag });
  const tagData = getPermissionTags.data?.permission_tags
    ?.find(({ permission_tag }) => permission_tag === permissionTag);

  const tagName = valueOrHyphen(tagData?.permission_tag);
  const createdAt = valueOrHyphen(parseISOToLocale(tagData?.create_time));

  return (
    <div className={st.Root}>
      <h6 className={st.Title}>
        {t('widgets:permission_tag_general_info.title')}
      </h6>

      <div className={st.Rows}>
        <div className={st.Row}>
          <span className={st.Label}>
            {t('widgets:permission_tag_general_info.data.name')}
          </span>
          <span className={st.TagName}>
            {tagName}
          </span>
        </div>

        <div className={st.Divider} />

        <div className={st.Row}>
          <span className={st.Label}>
            {t('widgets:permission_tag_general_info.data.created')}
          </span>
          <span className={st.CreatedAt}>
            {createdAt}
          </span>
        </div>
      </div>
    </div>
  );
}

export { PermissionTagGeneralInfo };
